<div class="mat-dialog-content" *ngIf="data.type=='image'">
    <img [src]="data.data" alt="Image" class="dialog-image" />
    <span class="material-symbols-rounded close-icon" (click)="closeDialog()">close</span>
</div>
<div class="mat-dialog-content" *ngIf="data.type=='table'">
    <div class="table-container">
        <div class="table-data-container" style="overflow-x: auto;">
            <table mat-table [dataSource]="dataSource">
                <ng-container *ngFor="let column of stickyColumnNames" [matColumnDef]="column" sticky>
                    <th mat-header-cell *matHeaderCellDef class="bold-header"> {{ column | titlecase }} </th>
                    <td mat-cell class="table-data" *matCellDef="let element"> {{ isUtcDate(element[column]) ?
                        convertToIST(element[column]) : element[column] }} </td>
                </ng-container>
                <ng-container *ngFor="let column of scrollableColumnNames" [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef class="bold-header"> {{ column | titlecase }} </th>
                    <td mat-cell class="table-data" *matCellDef="let element"> {{ isUtcDate(element[column]) ?
                        convertToIST(element[column]) : element[column] }} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="totalColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: totalColumns"></tr>
            </table>
        </div>
        <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
            [length]="tableDataSource?.data?.length" aria-label="Select page"></mat-paginator>
    </div>
</div>